// 腾讯广告归因采集
// 目前兼容所有情况：__CALLBACK__ / cb / gdt_vid / qz_gdt / clickid
// 腾讯返回链接："/?gdt_vid=xxx&tid=xxx&wx_aid=xxx&wx_traceid=xxx&height=xxx#/..."
// 落地页读取腾讯参数并存入sessionStorage
import ajax from '../http/ajax'

function parseQueryString (qs) {
    const params = {}
    if (!qs) return params

    const s = qs.startsWith('?') ? qs.slice(1) : qs
    if (!s) return params

    s.split('&').forEach((pair) => {
        if (!pair) return

        const parts = pair.split('=')
        const k = parts[0]
        const v = parts.length > 1 ? parts.slice(1).join('=') : ''

        if (!k) return

        params[safeDecode(k)] = safeDecode(v)
    })

    return params
}

/**
 * 安全解码,防止非法编码的参数值
 * 解码失败会返回原始字符串
 * @param {string} str 需要解码的字符串
 * @returns {string} 解码后的字符串或原始字符串
 */
function safeDecode (str) {
    try {
        return decodeURIComponent(str)
    } catch (e) {
        return str
    }
}

function parseHashQuery (hash) {
    // hash 形态可能是：
    // "#/goodsDetail?spu_id=1&gdt_vid=xxx"
    // "#/?id=147&gdt_vid=xxx"
    if (!hash) return {}

    const h = hash.startsWith('#') ? hash.slice(1) : hash
    const idx = h.indexOf('?')
    if (idx === -1) return {}

    return parseQueryString(h.slice(idx))
}

/**
 * 上报
 * @param {string} clickid 腾讯广告clickid
 * @returns {Promise<boolean>}
 */
function reportTencent (clickid) {
    try {
        if (!clickid) {
            return Promise.resolve(false)
        }

        return ajax.post('reportTencent', {
            clickid,
            channel: 2
        })
            .then(res => {
                console.log('advert/report 成功', res)
                return true
            })
            .catch(err => {
                console.log('advert/report 失败', err)
                return false
            })
    } catch (e) {
        console.log('advert/report 异常', e)
        return Promise.resolve(false)
    }
}

/**
 * 采集腾讯广告归因参数并写入sessionStorage
 * 落地页created时调用
 * - 本次URL有归因参数 => 覆盖旧值 + 调后端上报
 * - 本次URL没归因参数 => 清空旧值
 * @returns {Object|null}
 */
export function captureTencentAttribution () {
    const currentUrl = window.location.href
    const url = new URL(currentUrl)
    const fromSearch = parseQueryString(url.search)
    const fromHash = parseHashQuery(url.hash)

    // 合并fromSearch和fromHash中的所有字段
    const merged = Object.assign({}, fromHash, fromSearch)

    // 提取归因相关的参数
    const cb = merged.__CALLBACK__ || merged.cb || ''
    const clickid = merged.gdt_vid || merged.qz_gdt || merged.clickid || ''
    // 没有clickid就不保存
    if (!clickid) return

    // 包含归因参数及其他所有字段
    const payload = {
        ...merged,  // 包含fromSearch和fromHash中的所有参数
        cb,
        clickid,
        captured_at: Date.now(),
        landing_url: window.location.href
    }

    // 每次广告进入都更新
    sessionStorage.setItem('TENCENT_AD_ATTR', JSON.stringify(payload))

    // 存入缓存后，调用上报接口
    reportTencent(clickid)
    return payload
}

/**
 * 读取已存储的腾讯广告归因信息
 * @returns {Object|null}
 */
export function getTencentAttribution () {
    try {
        const raw = sessionStorage.getItem('TENCENT_AD_ATTR')
        return raw ? JSON.parse(raw) : null
    } catch (e) {
        return null
    }
}

/**
 * 生成不带归因的干净链接
 * @param {string} rawLink 传入当前链接
 * @returns {Object|null}
 */

export function buildCleanShareLink (rawLink) {
    try {
        const input = rawLink || window.location.href
        const url = new URL(input)

        // 要清理的归因参数
        const removeKeys = [
            'gdt_vid', 'qz_gdt', 'clickid',
            'cb', '__CALLBACK__',
            'wx_traceid', 'wx_aid', 'tid', 'height'
        ]

        // 清理 search
        removeKeys.forEach(k => url.searchParams.delete(k))

        // 清理 hash query
        let hash = url.hash || ''
        const idx = hash.indexOf('?')
        if (idx !== -1) {
            const hashPath = hash.slice(0, idx)
            const hashQuery = hash.slice(idx + 1)
            const sp = new URLSearchParams(hashQuery)
            removeKeys.forEach(k => sp.delete(k))
            const cleaned = sp.toString()
            hash = cleaned ? `${hashPath}?${cleaned}` : hashPath
        }

        const cleanSearch = url.searchParams.toString()
        const searchPart = cleanSearch ? `?${cleanSearch}` : ''
        const newUrl = `${url.origin}${url.pathname}${searchPart}${hash}`

        return newUrl
    } catch (e) {
        return rawLink || window.location.href
    }
}
